// Atlas manifest loader (Fase 3 asset pipeline).

export interface AtlasFrame {
  x: number;
  y: number;
  w: number;
  h: number;
}

export interface AtlasManifest {
  image: string;
  frames: Record<string, AtlasFrame>;
}

let manifest: AtlasManifest | null = null;

export async function loadAtlasManifest(url = './assets/atlas.json'): Promise<AtlasManifest | null> {
  if (manifest) return manifest;
  try {
    const res = await fetch(url);
    if (!res.ok) return null;
    manifest = (await res.json()) as AtlasManifest;
    return manifest;
  } catch {
    return null;
  }
}

export function getAtlasFrame(name: string): AtlasFrame | null {
  return manifest?.frames[name] ?? null;
}

export function resolveEntityFrame(renderId: string, frameName?: string): AtlasFrame | null {
  if (!manifest) return null;
  if (frameName && manifest.frames[frameName]) return manifest.frames[frameName];
  if (manifest.frames[renderId]) return manifest.frames[renderId];
  return null;
}

/** Reset for tests. */
export function resetAtlasCache(): void {
  manifest = null;
}
